import React from 'react';
import PDU from './PDU';
import {Link, useParams} from 'react-router-dom';

const CabDetail = ({api, user}) => {
  let {dcId, cabId} = useParams();

  let dc = api.data.datacentres.find(d => parseInt(d.id) == dcId);
  if(!dc) {
    return <div className="alert alert-danger">Datacentre not found</div>
  }
  let cab = dc.cabs.find(r => parseInt(r.id) == cabId);

  if(!cab) {
    return <div className="alert alert-danger">Cab not found</div>
  }

  const refreshCab = () => {
    api.refreshCab(cab.id)
  }

  return <div>
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/">Datacentres</Link></li>
        <li className="breadcrumb-item"><Link to={"/datacentre/" + dcId}>{dc.name}</Link></li>
        <li className="breadcrumb-item active" aria-current="page">{cab.cabId}{cab.name === null ? '' : `: ${cab.name}`}</li>
      </ol>
    </nav>
    <h3>{cab.cabId}{cab.name === null ? '' : `: ${cab.name}`}<a className="btn btn-primary ml-1" onClick={refreshCab}>Rediscover</a></h3>
    <div className="row">{cab.pdus.map(p => <PDU key={"pdu_" + p.id} pdu={p} api={api} user={user}></PDU>)}</div>
  </div>
}

export default CabDetail;